import { BusinessContextModel } from '../../../core/model/BusinessContext.model';
import { ThroughputMonitoredServiceQuery } from './BitrateStatisticsServiceQuery.config';

export const BitrateStatisticsBusinessContextConfig: BusinessContextModel = {
  queries: ThroughputMonitoredServiceQuery,
  translateNamespace: 'bitrateStatistics'
}
